import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom";

const MenuSingleBtn = (props) => {
  const { href_btn, title } = props;
  const navigate = useNavigate();
  const handleCloseNavMenu = () => {
    navigate(`${href_btn}`);
  };
  return (
    <>
      <Box
        sx={{
          my: 2,
          color: "#005096",
          display: "flex",
          borderRadius: "25px",
          paddingX: "3%",
        }}
      >
        <NavLink
          onClick={handleCloseNavMenu}
          style={{ color: "#005096", textDecoration: "none" }}
          to={href_btn}
        >
          <Typography
            sx={{
              "&:hover": {
                backgroundColor: "#005096",
                color: "#fff",
                borderRadius: "25px",
              },
              fontWeight: 500,
              fontSize: "15px",
              textDecoration: "uppercase",
              paddingX: "35px",
            }}
          >
            {title}
          </Typography>
        </NavLink>
      </Box>
    </>
  );
};

export default MenuSingleBtn;
